export default __webpack_public_path__ + "076a3dbcbe0fc092254fdc893b157663.svg";